import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Fade,
  Divider,
  useMediaQuery,
  useTheme,
  Tooltip,
  IconButton,
  Backdrop,
  Card,
  CardContent,
  Chip,
  Stack,
  Button,
  SwipeableDrawer
} from "@mui/material";
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import ViewListIcon from '@mui/icons-material/ViewList';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CakeIcon from '@mui/icons-material/Cake';
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';

import DashboardGlobalSearch from "./DashboardGlobalSearch";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerDataAction, getCustomerListAction, getNotesListDataAction,
  getQuoteListDataAction, getTaskListDataAction } from '../../../redux/actions/customerSearchAction';
import { getSelectedCustomerDetails, getCustomerDetailsByIdAction } from '../../../redux/actions/customerDetailsAction';
import { getGeneralPartyInfoByIdDashboard } from "../../../redux/actions/generalPartyInfoActions";
import { getClientCustomerId } from '../../../redux/actions/taskActions';
import CustomerSearchResultList from "./CustomerSearchResultList";
import CustomerData from "./CustomerData";
import Loader from "../../loader/loader";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  getCustomerListSelector,
  getCustomerListPaginationSelector,
  getCustomerQuoteDataSelector,
  getCustomerQuotePaginationSelector,
  getSelectedCustomerList,
  getSelectedCustomerListPagination
} from '../../../redux/selectors/globalSearchSelectors';
import { getPolicyListingAction } from "../../../redux/actions/customerDetailsAction";
import NoDataFound from "../../../common/NoDataFound";

const GlobalSearch = () => {
  const [searchPerformed, setSearchPerformed] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [newCustomer, setNewCustomer] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [showCustomerData, setShowCustomerData] = useState(true);
  const [searchData, setSearchData] = useState([]);
  const [customerPage, setCustomerPage] = useState(0);
  const [customerRowsPerPage, setCustomerRowsPerPage] = useState(5);
  const [policyPage, setPolicyPage] = useState(0);
  const [policyRowsPerPage, setPolicyRowsPerPage] = useState(5);
  const [expandedView, setExpandedView] = useState(true);
  const [fullView, setFullView] = useState(false);
  const [customerSelecteCustomer, setCustomerSelecteCustomer] = useState([]);

  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const [mobileViewMode, setMobileViewMode] = useState('list');
  const [selectedCustomerDrawer, setSelectedCustomerDrawer] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { id, showPolicyDetails, clientCustomerId } = location.state || {};
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const isLoading = useSelector((state) => state.globalSearchReducer.loading);
  const customer_policy_pagination = useSelector(getSelectedCustomerListPagination);
  const selected_customer_list = useSelector(getSelectedCustomerList);
  const get_customer_list = useSelector(getCustomerListSelector);
  const get_customer_list_pagination = useSelector(getCustomerListPaginationSelector);
  const get_selected_quote_data = useSelector(getCustomerQuoteDataSelector);
  const get_selected_quote_data_pagination = useSelector(getCustomerQuotePaginationSelector);

  const dispatch = useDispatch();

  useEffect(() => {
    if (isMobile) {
      setExpandedView(false);
      setFullView(false);
      setRowsPerPage(3);
    } else if (isTablet) {
      setExpandedView(true);
      setRowsPerPage(5);
    }
  }, [isMobile, isTablet]);

  useEffect(() => {
    if (showPolicyDetails && id && id !== clientCustomerId) {
      dispatch(getCustomerDataAction(id, clientCustomerId, policyPage, policyRowsPerPage));
    }
  }, [
    id,
    clientCustomerId,
    showPolicyDetails,
    dispatch,
    policyPage,
    policyRowsPerPage,
  ]);

  useEffect(() => {
    if (clientCustomerId) {
      dispatch(getCustomerDetailsByIdAction(clientCustomerId));
      dispatch(getClientCustomerId(clientCustomerId));
    }
  }, [clientCustomerId, dispatch]);

  useEffect(() => {
    setSelectedRow(newCustomer?.id);
    setSelectedCustomer(newCustomer?.id);
  }, [dispatch]);

  const handleRowClick = (id, selected_customer_data) => {
    setCustomerSelecteCustomer(selected_customer_data);
    setTabValue(0);
    setSelectedRow(id);
    setSelectedCustomer(id);
    setShowCustomerData(true);
    setExpandedView(true);

    if (isMobile) {
      setMobileDrawerOpen(false);
      setSelectedCustomerDrawer(true);
    }

    dispatch(getCustomerDataAction(id, policyPage, policyRowsPerPage));
    dispatch(getQuoteListDataAction(id, customerPage, customerRowsPerPage));
    dispatch(getNotesListDataAction(id, customerPage, customerRowsPerPage));
    dispatch(getTaskListDataAction(id, customerPage, customerRowsPerPage));
    dispatch({ type: 'GET_CUSTOMER_POICY_CLEAR_DATA_SUCCESS' });
    dispatch(getPolicyListingAction(id, policyPage, policyRowsPerPage));
  
  };

  useEffect(() => {
    dispatch({ type: 'CLEAR_GET_CLIENT_SUCCESS' });
    dispatch({ type: 'CLEAR_GET_CUSTOMER_DETAILS_SUCCESS' });
    dispatch({ type: 'CLEAR_CUSTOMER_SEARCH_LIST_SUCCESS' });
    dispatch({ type: 'GET_CUSTOMER_POICY_CLEAR_DATA_SUCCESS' });
    if (newCustomer?.id) {
      setTabValue(0);
      setSelectedRow(newCustomer.id);
      setSelectedCustomer(newCustomer.id);
    }
  }, [dispatch, newCustomer]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(getCustomerListAction(searchData, newPage, rowsPerPage));
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    dispatch(getCustomerListAction(searchData, 0, newRowsPerPage));
  };

  const handlePolicyChangePage = (event, newPage) => {
    setPolicyPage(newPage);
    dispatch(getCustomerDataAction(selectedCustomer, newPage, policyRowsPerPage));
  };

  const handlePolicyChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setPolicyRowsPerPage(newRowsPerPage);
    setPage(0);
    dispatch(getCustomerDataAction(selectedCustomer, 0, newRowsPerPage));
  };

  const handleQuotePolicyChangePage = (event, newPage) => {
    setCustomerPage(newPage);
    dispatch(getQuoteListDataAction(selectedCustomer, newPage, policyRowsPerPage));
  };

  const handleQuoteChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setCustomerRowsPerPage(newRowsPerPage);
    setPage(0);
    dispatch(getQuoteListDataAction(selectedCustomer, 0, newRowsPerPage));
  };

  const handleRowClickQuotes = async (quoteNumber) => {
    if (!quoteNumber) {
      console.error("quoteNumber is undefined or missing.");
      return;
    }
    const numericPart = quoteNumber.replace(/^Q0*/, "");
    try {
      const response = await dispatch(getGeneralPartyInfoByIdDashboard(numericPart));
      const generalData = response?.payload || response;
      if (generalData && Object.keys(generalData).length > 0) {
        navigate("/mainview", { state: { generalData } });
      } else {
        console.error("No general data returned.");
      }
    } catch (error) {
      console.error("Error fetching general party info:", error);
    }
  };

  const toggleExpandedView = () => {
    setExpandedView(!expandedView);
  };

  const toggleFullView = () => {
    setFullView(!fullView);
  };

  const toggleMobileViewMode = () => {
    setMobileViewMode(mobileViewMode === 'list' ? 'cards' : 'list');
  };

  const selectedCustomerDetails = useMemo(() => {
    return get_customer_list?.find(customer => customer.id === selectedRow) || newCustomer || null;
  }, [get_customer_list, selectedRow, newCustomer]);

  useEffect(() => {
    if (selectedCustomerDetails) {
      dispatch(getSelectedCustomerDetails(selectedCustomerDetails));
    }
  }, [dispatch, selectedCustomerDetails]);

  useEffect(() => {
    if (
      id &&
      showPolicyDetails &&
      selectedCustomerDetails &&
      get_customer_list.length === 0
    ) {
      dispatch({
        type: 'CUSTOMER_SEARCH_LIST_SUCCESS',
        type: 'GET_CUSTOMER_LIST_SUCCESS',
        payload: {
          content: [selectedCustomerDetails],
          totalElements: 1,
          totalPages: 1,
          number: 0,
          size: 5,
        },
      });
    }
  }, [id, showPolicyDetails, selectedCustomerDetails, get_customer_list.length, dispatch]);

  const handleSearch = (searchParams) => {
    setSearchData(searchParams);
    setPage(0);
    dispatch(getCustomerListAction(searchParams, 0, rowsPerPage));
  };

  const MobileCustomerCard = ({ customer, isSelected, onClick }) => {
    const formatAddress = (customer) => {
      const addressParts = [
        customer.address1,
        customer.address2,
        customer.city,
        customer.state,
        customer.zipCode
      ].filter(Boolean);
      return addressParts.join(', ');
    };

    const formatDate = (dateString) => {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    };

    return (
      <Card
        sx={{
          mb: 2,
          cursor: 'pointer',
          backgroundColor: isSelected ? 'rgba(66, 133, 244, 0.08)' : 'white',
          transition: 'all 0.2s ease',
          '&:hover': {
            backgroundColor: isSelected ? 'rgba(66, 133, 244, 0.15)' : 'rgba(0, 0, 0, 0.04)',
            transform: 'translateY(-2px)',
            boxShadow: 3
          }
        }}
        onClick={() => onClick(customer.id, customer)}
      >
        <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <PersonIcon sx={{mr: 1, fontSize: 20 }} />
            <Typography
              variant="subtitle1"
            >
              {customer.firstName} {customer.lastName}
            </Typography>
            {isSelected && (
              <Chip
                label="Selected"
                size="small"
                sx={{
                  color: 'white',
                  fontSize: '0.7rem'
                }}
              />
            )}
          </Box>

          <Stack spacing={1}>
            {customer.email && (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <EmailIcon sx={{ color: '#67748e', mr: 1, fontSize: 16 }} />
                <Typography variant="body2">
                  {customer.email}
                </Typography>
              </Box>
            )}

            {customer.dateOfBirth && (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <CakeIcon sx={{ color: '#67748e', mr: 1, fontSize: 16 }} />
                <Typography variant="body2">
                  {formatDate(customer.dateOfBirth)}
                </Typography>
              </Box>
            )}

            {formatAddress(customer) && (
              <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                <LocationOnIcon sx={{ color: '#67748e', mr: 1, fontSize: 16, mt: 0.2 }} />
                <Typography
                  variant="body2"
                  sx={{
                    color: '#67748e',
                    fontSize: '0.85rem',
                    lineHeight: 1.3
                  }}
                >
                  {formatAddress(customer)}
                </Typography>
              </Box>
            )}
          </Stack>
        </CardContent>
      </Card>
    );
  };

  const EnhancedCustomerSearch = (props) => {
    const {
      get_customer_list,
      handleRowClick,
      searchPerformed,
      get_customer_list_pagination,
      selectedRow,
      fullView
    } = props;

    const formatAddress = (customer) => {
      const addressParts = [
        customer.address1,
        customer.address2,
        customer.city,
        customer.state,
        customer.zipCode
      ].filter(Boolean);
      return addressParts.join(', ');
    };

    const formatDate = (dateString) => {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    };

    if (isMobile) {
      return (
        <Box sx={{ p: 2 }}>
          {searchPerformed && get_customer_list.length > 0 ? (
            <>
              <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2">
                  {get_customer_list_pagination?.totalElements || 0} results
                </Typography>
                <IconButton size="small" onClick={toggleMobileViewMode}>
                  {mobileViewMode === 'list' ? <ViewModuleIcon /> : <ViewListIcon />}
                </IconButton>
              </Box>

              {mobileViewMode === 'cards' ? (
                <Box>
                  {get_customer_list.map((customer) => (
                    <MobileCustomerCard
                      key={customer.id}
                      customer={customer}
                      isSelected={selectedRow === customer.id}
                      onClick={handleRowClick}
                    />
                  ))}
                </Box>
              ) : (
                <Box sx={{ overflow: 'auto' }}>
                  {get_customer_list.map((customer) => (
                    <Paper
                      key={customer.id}
                      sx={{
                        p: 2,
                        mb: 1,
                        cursor: 'pointer',
                        backgroundColor: selectedRow === customer.id ? 'rgba(66, 133, 244, 0.08)' : 'white',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          backgroundColor: selectedRow === customer.id
                            ? 'rgba(66, 133, 244, 0.15)'
                            : 'rgba(0, 0, 0, 0.04)',
                        }
                      }}
                      onClick={() => handleRowClick(customer.id, customer)}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 600,
                          mb: 0.5
                        }}
                      >
                        {customer.firstName} {customer.lastName}
                      </Typography>
                      <Typography variant="caption" sx={{ color: '#67748e' }}>
                        {customer.email || 'No email'}
                      </Typography>
                    </Paper>
                  ))}
                </Box>
              )}
            </>
          ) : searchPerformed ? (
            <Box sx={{
              py: 4,
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center'
            }}>
              <Typography sx={{ color: '#67748e', mb: 1, textAlign: 'center' }}>
                No results found for your search.
              </Typography>
              <Typography variant="body2" sx={{ color: '#8392ab', textAlign: 'center' }}>
                Try a different search term or criteria.
              </Typography>
            </Box>
          ) : null}
        </Box>
      );
    }

    return (
      <Box sx={{ p: 2 }}>
        {searchPerformed && get_customer_list.length > 0 ? (
          <>
            <Box sx={{ overflow: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={{
                      padding: '12px 8px',
                      textAlign: 'left',
                      borderBottom: '2px solid #e0e0e0',
                      color: '#344767',
                      fontWeight: 600
                    }}>
                      Name
                    </th>

                    {(fullView || isDesktop) && (
                      <>
                        <th style={{
                          padding: '12px 8px',
                          textAlign: 'left',
                          borderBottom: '2px solid #e0e0e0',
                          color: '#344767',
                          fontWeight: 600
                        }}>
                          Date of Birth
                        </th>
                        <th style={{
                          padding: '12px 8px',
                          textAlign: 'left',
                          borderBottom: '2px solid #e0e0e0',
                          color: '#344767',
                          fontWeight: 600
                        }}>
                          Email
                        </th>
                        <th style={{
                          padding: '12px 8px',
                          textAlign: 'left',
                          borderBottom: '2px solid #e0e0e0',
                          color: '#344767',
                          fontWeight: 600
                        }}>
                          Address
                        </th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {get_customer_list.map((customer) => (
                    <tr
                      key={customer.id}
                      onClick={() => handleRowClick(customer.id, customer)}
                      style={{
                        cursor: 'pointer',
                        backgroundColor: selectedRow === customer.id ? 'rgba(66, 133, 244, 0.08)' : 'transparent',
                        transition: 'background-color 0.2s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = selectedRow === customer.id
                          ? 'rgba(66, 133, 244, 0.15)'
                          : 'rgba(0, 0, 0, 0.04)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = selectedRow === customer.id
                          ? 'rgba(66, 133, 244, 0.08)'
                          : 'transparent';
                      }}
                    >
                      <td style={{
                        padding: '14px 8px',
                        borderBottom: '1px solid #e0e0e0',                        
                        fontWeight: selectedRow === customer.id ? 500 : 400
                      }}>
                        {customer.firstName} {customer.lastName}
                      </td>

                      {(fullView || isDesktop) && (
                        <>
                          <td style={{
                            padding: '14px 8px',
                            borderBottom: '1px solid #e0e0e0',
                            color: '#67748e'
                          }}>
                            {formatDate(customer.dateOfBirth)}
                          </td>
                          <td style={{
                            padding: '14px 8px',
                            borderBottom: '1px solid #e0e0e0',
                            color: '#67748e'
                          }}>
                            {customer.email || 'N/A'}
                          </td>
                          <td style={{
                            padding: '14px 8px',
                            borderBottom: '1px solid #e0e0e0',
                            color: '#67748e'
                          }}>
                            {formatAddress(customer)}
                          </td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </Box>
          </>
        ) : searchPerformed ? (
          <Box sx={{
            py: 6,
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center'
          }}>
            <Typography sx={{ color: '#67748e', mb: 1 }}>
              No results found for your search.
            </Typography>
            <Typography variant="body2" sx={{ color: '#8392ab' }}>
              Try a different search term or criteria.
            </Typography>
          </Box>
        ) : null}
      </Box>
    );
  };

  return (
    <Fade in={true} timeout={800}>
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
        mx: 'auto',
        px: { xs: 1, sm: 2, md: 3, lg: 4 },
        py: { xs: 1, sm: 2, md: 3 },
        minHeight: '100vh'
      }}>
        <Paper
          elevation={3}
          sx={{
            p: { xs: 2, sm: 3 },
            mb: { xs: 2, md: 4 },
            borderRadius: { xs: '8px', md: '12px' },
            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
            position: 'relative',
            overflow: 'visible',
            zIndex: 5,
          }}
        >
          <Box sx={{ position: 'relative', zIndex: 2 }}>
            <Typography
              variant={isMobile ? "h6" : "h2"}
            >
              Customer Explorer
            </Typography>
            <Typography
              variant="body2"
              sx={{
                mb: { xs: 2, md: 3 },
                color: '#67748e',
                fontSize: { xs: '0.85rem', md: '0.875rem' }
              }}
            >
              Search for customers by name, email, or policy number
            </Typography>
            <DashboardGlobalSearch
              setTabValue={setTabValue}
              setSelectedRow={setSelectedRow}
              setSelectedCustomer={setSelectedCustomer}
              clientCustomerId={clientCustomerId}
              handleRowClick={handleRowClick}
              customerPage={customerPage}
              customerRowsPerPage={customerRowsPerPage}
              setNewCustomer={setNewCustomer}
              policyRowsPerPage={policyRowsPerPage}
              policyPage={policyPage}
              setPolicyPage={setPolicyPage}
              setShowCustomerData={setShowCustomerData}
              setSearchPerformed={setSearchPerformed}
              setExpandedView={setExpandedView}
              setSearchData={setSearchData}
              page={page}
              rowsPerPage={rowsPerPage}
              handleChangePage={handleChangePage}
              searchPerformed={searchPerformed}
              onSearch={handleSearch}
            />
          </Box>

          <Box
            sx={{
              position: 'absolute',
              top: { xs: -10, md: -20 },
              right: { xs: -10, md: -20 },
              width: { xs: '80px', md: '150px' },
              height: { xs: '80px', md: '150px' },
              borderRadius: '50%',
              background: 'rgba(66, 133, 244, 0.08)',
              zIndex: 1
            }}
          />
        </Paper>

        {isLoading && (
          <Backdrop
            sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
            open={isLoading}
          >
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
              <Loader/>
            </Box>
          </Backdrop>
        )}

        {isMobile && searchPerformed ? (
          <>
            <Box sx={{ mb: 2 }}>
              <Button
                variant="outlined"
                startIcon={<MenuIcon />}
                onClick={() => setMobileDrawerOpen(true)}
                fullWidth
                sx={{
                  justifyContent: 'flex-start',
                  py: 1.5,
                  borderColor: '#e0e0e0',
                  color: '#344767',
                }}
              >
                Customer Results ({get_customer_list?.length || 0})
              </Button>
            </Box>

            <SwipeableDrawer
              anchor="bottom"
              open={mobileDrawerOpen}
              onClose={() => setMobileDrawerOpen(false)}
              onOpen={() => setMobileDrawerOpen(true)}
              PaperProps={{
                sx: {
                  maxHeight: '80vh',
                  borderTopLeftRadius: 16,
                  borderTopRightRadius: 16
                }
              }}
            >
              <Box sx={{ p: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, color: '#344767' }}>
                    Customer Results
                  </Typography>
                  <IconButton onClick={() => setMobileDrawerOpen(false)}>
                    <CloseIcon />
                  </IconButton>
                </Box>
                <EnhancedCustomerSearch
                  get_customer_list={get_customer_list}
                  handleRowClick={handleRowClick}
                  searchPerformed={searchPerformed}
                  get_customer_list_pagination={get_customer_list_pagination}
                  selectedRow={selectedRow}
                  isLoading={isLoading}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                  handleChangePage={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  fullView={fullView}
                />
              </Box>
            </SwipeableDrawer>

            <SwipeableDrawer
              anchor="right"
              open={selectedCustomerDrawer}
              onClose={() => setSelectedCustomerDrawer(false)}
              onOpen={() => setSelectedCustomerDrawer(true)}
              PaperProps={{
                sx: {
                  width: '100%',
                  maxWidth: '100vw'
                }
              }}
            >
              <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <Box sx={{
                  p: 2,
                  borderBottom: '1px solid #e0e0e0',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, color: '#344767' }}>
                    Customer Details
                  </Typography>
                  <IconButton onClick={() => setSelectedCustomerDrawer(false)}>
                    <CloseIcon />
                  </IconButton>
                </Box>
                <Box sx={{ flex: 1, overflow: 'auto' }}>
                  {showCustomerData && (
                    <CustomerData
                      id={id}
                      showPolicyDetails={showPolicyDetails}
                      clientCustomerId={clientCustomerId}
                      setSearchPerformed={setSearchPerformed}
                      showCustomerData={showCustomerData}
                      selected_customer_list={selected_customer_list}
                      selectedCustomer={selectedCustomer}
                      get_selected_quote_data_pagination={get_selected_quote_data_pagination}
                      customer_policy_pagination={customer_policy_pagination}
                      get_selected_quote_data={get_selected_quote_data}
                      handleRowClickQuotes={handleRowClickQuotes}
                      customerRowsPerPage={customerRowsPerPage}
                      customerPage={customerPage}
                      handleQuotePolicyChangePage={handleQuotePolicyChangePage}
                      handleQuoteChangeRowsPerPage={handleQuoteChangeRowsPerPage}
                      handlePolicyChangePage={handlePolicyChangePage}
                      handlePolicyChangeRowsPerPage={handlePolicyChangeRowsPerPage}
                      policyRowsPerPage={policyRowsPerPage}
                      policyPage={policyPage}
                      selectedCustomerDetails={selectedCustomerDetails || null}
                      tabValue={tabValue}
                      setTabValue={setTabValue}
                      customerSelecteCustomer={customerSelecteCustomer}
                    />
                  )}
                </Box>
              </Box>
            </SwipeableDrawer>

            {showCustomerData && !selectedCustomerDrawer && selectedCustomer && (
              <Paper
                elevation={2}
                sx={{
                  borderRadius: '12px',
                  overflow: 'hidden',
                  mt: 2
                }}
              >
                <CustomerData
                  id={id}
                  showPolicyDetails={showPolicyDetails}
                  clientCustomerId={clientCustomerId}
                  setSearchPerformed={setSearchPerformed}
                  showCustomerData={showCustomerData}
                  selected_customer_list={selected_customer_list}
                  selectedCustomer={selectedCustomer}
                  get_selected_quote_data_pagination={get_selected_quote_data_pagination}
                  customer_policy_pagination={customer_policy_pagination}
                  get_selected_quote_data={get_selected_quote_data}
                  handleRowClickQuotes={handleRowClickQuotes}
                  customerRowsPerPage={customerRowsPerPage}
                  customerPage={customerPage}
                  handleQuotePolicyChangePage={handleQuotePolicyChangePage}
                  handleQuoteChangeRowsPerPage={handleQuoteChangeRowsPerPage}
                  handlePolicyChangePage={handlePolicyChangePage}
                  handlePolicyChangeRowsPerPage={handlePolicyChangeRowsPerPage}
                  policyRowsPerPage={policyRowsPerPage}
                  policyPage={policyPage}
                  selectedCustomerDetails={selectedCustomerDetails || null}
                  tabValue={tabValue}
                  setTabValue={setTabValue}
                  customerSelecteCustomer={customerSelecteCustomer}
                />
              </Paper>
            )}
          </>
        ) : (
          searchPerformed && (
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: expandedView ? 'row' : 'column' },
                gap: { xs: 2, md: 3 }
              }}
            >
              <Paper
                elevation={2}
                sx={{
                  width: {
                    xs: '100%',
                    md: expandedView ? '30%' : '100%',
                    lg: expandedView ? '25%' : '100%'
                  },
                  borderRadius: { xs: '8px', md: '12px' },
                  transition: 'all 0.3s ease',
                  overflow: 'hidden'
                }}
              >
                <Box className="styled-table-heading" sx={{
                  p: 2,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: 1
                }}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      color: 'Black',
                      fontWeight: 500,
                      fontSize: { xs: '1rem', md: '1.1rem' }
                    }}
                  >
                    Customer Results
                  </Typography>
                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {!isMobile && (
                    <Tooltip title={expandedView ? "Simple View" : "Full View"}>
                      <IconButton
                        size="small"
                        onClick={toggleExpandedView}
                        sx={{ color: 'Black' }}
                      >
                        {expandedView ? <FullscreenExitIcon /> : <FullscreenIcon />}
                      </IconButton>
                    </Tooltip>
                  )}

                  {isDesktop && (
                    <Typography
                      variant="body2"
                      sx={{
                        color: 'rgba(15, 2, 2, 0.94)',
                        cursor: 'pointer',
                        fontSize: '0.85rem',
                        whiteSpace: 'nowrap',
                        '&:hover': {
                          color: 'Black',
                          textDecoration: 'underline'
                        }
                      }}
                      onClick={toggleExpandedView}
                    >
                      {expandedView ? 'Full View' : 'Split View'}
                    </Typography>
                  )}
                </Box>

                </Box>
                <Divider />
                <CustomerSearchResultList
                  clientCustomerId={clientCustomerId}
                  newCustomer={newCustomer}
                  get_customer_list={get_customer_list}
                  handleRowClick={handleRowClick}
                  searchPerformed={searchPerformed}
                  get_customer_list_pagination={get_customer_list_pagination}
                  selectedRow={selectedRow}
                  isLoading={isLoading}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                  handleChangePage={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  fullView={fullView}
                />
              </Paper>

              {showCustomerData && (
                <Fade in={showCustomerData} timeout={500}>
                  <Paper
                    elevation={2}
                    sx={{
                      width: {
                        xs: '100%',
                        md: expandedView ? '70%' : '100%',
                        lg: expandedView ? '75%' : '100%'
                      },
                      borderRadius: { xs: '8px', md: '12px' },
                      transition: 'all 0.3s ease',
                      overflow: 'hidden'
                    }}
                  >
                    <CustomerData
                      id={id}
                      showPolicyDetails={showPolicyDetails}
                      clientCustomerId={clientCustomerId}
                      setSearchPerformed={setSearchPerformed}
                      showCustomerData={showCustomerData}
                      selected_customer_list={selected_customer_list}
                      selectedCustomer={selectedCustomer}
                      get_selected_quote_data_pagination={get_selected_quote_data_pagination}
                      customer_policy_pagination={customer_policy_pagination}
                      get_selected_quote_data={get_selected_quote_data}
                      handleRowClickQuotes={handleRowClickQuotes}
                      customerRowsPerPage={customerRowsPerPage}
                      customerPage={customerPage}
                      handleQuotePolicyChangePage={handleQuotePolicyChangePage}
                      handleQuoteChangeRowsPerPage={handleQuoteChangeRowsPerPage}
                      handlePolicyChangePage={handlePolicyChangePage}
                      handlePolicyChangeRowsPerPage={handlePolicyChangeRowsPerPage}
                      policyRowsPerPage={policyRowsPerPage}
                      policyPage={policyPage}
                      selectedCustomerDetails={selectedCustomerDetails || null}
                      tabValue={tabValue}
                      setTabValue={setTabValue}
                      customerSelecteCustomer={customerSelecteCustomer}
                    />
                  </Paper>
                </Fade>
              )}
            </Box>
          )
        )}

        {!searchPerformed && !isLoading && (
          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            mt: { xs: 4, md: 8 },
            flexDirection: 'column',
            px: 2
          }}>
            <NoDataFound discription={"You can search by customer name, email address, phone number, or policy number to get started."} />
          </Box>
        )}
      </Box>
    </Fade>
  );
};

export default GlobalSearch;